module.exports = __webpack_public_path__ + "static/designweb-og-image-b10ec0f73d1d8fbcb5ac33806348dbb4.jpg";